<template>
  <a-modal
    :title="`${activeMenuData.rolename}-${item.name}：${title}`"
    :visible="isLimitDialogShow"
    :ok-text="okTTxt"
    :cancel-text="cancelTxt"
    width="760px"
    :mask-closable="false"
    :confirm-loading="confirmLoading"
    :destroy-on-close="true"
    wrap-class-name="set-feilds-dialog"
    @ok="formHandle"
    @cancel="isLimitDialogShow=false"
  >
    <div class="set-feilds-dia clearfix">
      <div class="fields-list">
        <h2>{{ $t('message["570"]') }}</h2>
        <div class="fileds-list-item">
          <!-- <a-checkbox-group
            :value="checkedValues"
            @change="onChange"
          > -->
          <ul class="field-list-box">
            <li
              v-for="allItem in configData.allconfig"
              :key="allItem.fieldkey"
            >
              <a-checkbox
                :value="allItem.fieldkey"
                :checked="!!allItem.ischecked"
                :disabled="!!allItem.issystem"
                @change="onChange"
              >
                {{ allItem. fieldname }}
              </a-checkbox>
            </li>
          </ul>
          <!-- </a-checkbox-group> -->
        </div>
      </div>
      <div class="fields-list checked-fields-list">
        <h2>{{ $t('message["1480"]') }}</h2>
        <div class="fileds-list-item scroll_bar_beautify_ff">
          <ul class="checked-field-list-box">
            <draggable
              v-model="configList"
              :options="{
                animation: 60,
                handle:'.dray-item'
              }"
              class="result"
              @end="dragEndHandle"
            >
              <transition-group>
                <li
                  v-for="checkedItem in configList"
                  :key="checkedItem.fieldkey"
                >
                  <div class="dray-item fl">
                    <i class="iconfont iconicon-test72 move-icon" />
                    <span class="txt-w">{{ checkedItem.fieldname }}</span>
                  </div>
                  <i
                    v-if="!checkedItem.issystem"
                    class="iconfont iconicon-test5 fr close-icon"
                    @click="delItem(checkedItem)"
                  />
                </li>
              </transition-group>
            </draggable>
          </ul>
        </div>
      </div>
    </div>
  </a-modal>
</template>
<script>
import { mapActions, mapState } from 'vuex'
export default {
  components: {
  },
  props: {
    type: {
      type: Number,
      default: 0
    },
    configData: {
      type: Object,
      default () {
        return {

        }
      }
    },
    item: {
      type: Object,
      default () {
        return {}
      }
    },
    name: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      submiting: false,
      isLimitDialogShow: false,
      confirmLoading: false,
      configList: []
    }
  },
  computed: {
    ...mapState('config/setlist', ['activeMenuData']),
    title () {
      const { pcM } = this
      return this.type === 1 ? pcM[0] : pcM[1]
    },
    // lastConfigData () {
    //   const { configList = [] } = this
    //   let obj = {}
    //   configList.forEach(item => {
    //     obj[item.fieldkey] = item
    //   })
    //   return obj
    // },
    maxLen () {
      const { type } = this
      return type === 1 ? 15 : 7
    },
    pcM () {
      return this.$t('message["236"]').split('|')
    },
    cancelTxt () {
      return this.$t('message["896"]')
    },
    okTTxt () {
      return this.$t('message["926"]')
    },
    setTip () {
      return this.$t('message["1680"]').split('|')
    }
  },
  watch: {
    isLimitDialogShow (val) {
      if (val) {
        const { config } = this.configData
        this.configList = Object.values(config)
      }
    }
  },
  methods: {
    ...mapActions('config/setlist', ['setFieldsDatas']),
    changeVisible (isShow) {
      this.isLimitDialogShow = isShow
    },
    async formHandle () {
      const { item, type, activeMenuData } = this
      const { configList = [] } = this
      // console.log(JSON.stringify(obj, null, 2))
      if (configList.length >= 1) {
        const chain = await this.setFieldsDatas()
        chain.params({
          roleid: activeMenuData.roleid,
          scopestr: item.scopestr,
          device: type,
          config: configList.map(item => item.fieldkey),
          system_role: activeMenuData.system_role
        })
          .onSuccess(raw => {
            this.isLimitDialogShow = false
          })
          .fetch()
      } else {
        this.$message.warning(this.$t('message["1310"]'))
      }
    },
    onChange (e) {
      const b = e.target.checked
      const fieldkey = e.target.value
      const { allconfig } = this.configData
      let { title, maxLen, configList = [] } = this
      let indexCur = 16
      for (let key in allconfig) {
        if (fieldkey === allconfig[key].fieldkey) {
          if (b) {
            if (configList.length < maxLen) {
              allconfig[key].ischecked = 1
              configList.push(allconfig[key])
            } else {
              this.$message.warning(`${title}${this.setTip[0]}${maxLen}${this.setTip[1]}`)
            }
          } else {
            allconfig[key].ischecked = 0
            // this.$delete(config, fieldkey)
            configList.forEach((item, index) => {
              if (fieldkey === item.fieldkey) {
                indexCur = index
              }
            })
            configList.splice(indexCur, 1)
          }
        }
      }
    },
    delItem (item) {
      const { configList = [] } = this
      const { allconfig } = this.configData
      const fieldkey = item.fieldkey
      let indexCur = 0
      allconfig[fieldkey].ischecked = 0
      configList.forEach((item2, index) => {
        if (fieldkey === item2.fieldkey) {
          indexCur = index
        }
      })
      configList.splice(indexCur, 1)
    },
    dragEndHandle () {
    },
    getConfigList (value) {
      this.configList = Object.values(value)
    }
  }
}
</script>

<style lang="scss">
.set-feilds-dialog {
  .ant-modal-body {
    padding: 16px 40px;
  }
}
</style>
<style lang="scss" scoped>
  .set-feilds-dia::v-deep {
    .fields-list {
      float: left;
      width: 320px;
      height: 408px;
      border-right: 1px solid #ebebeb;
      h2 {
        line-height: 48px;
        font-size: 14px;
        font-weight: bold;
      }
    }
    .fileds-list-item {
      height: 320px;
      overflow-y: auto;
      width: 304px;
      line-height: 32px;
      .txt-w {
        max-width: 240px;
        overflow: hidden;
        height: 32px;
        display: inline-block;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
    .field-list-box {
      li {
        height: 32px;
        overflow: hidden;
        line-height: 32px;
      }
    }
    .checked-fields-list {
      float: right;
      border: none;
      li {
      overflow: hidden;
      height: 32px;
      line-height: 32px;
      padding: 0 12px;
      &:hover {
        background-color: #f4f7f9;
        .iconfont.move-icon {
          opacity: 1;
        }
      }
    }
       .dray-item {
      cursor: move;
    }
    .iconfont.move-icon {
      opacity: 0;
      margin-right: 4px;
      color: #ccc;
      float: left;
    }
    .iconfont.close-icon {
      cursor: pointer;
      color: #d6d6d6;
    }
    }
  }
</style>
